export default __webpack_public_path__ + "static/media/ica-dunes_&_sunset.80795cdc.jpg";